// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  iaiServerUserId: "46279",
  iaiServer1UserId: "46512",
  arachimL1UserId: "46317",
  arachimL2UserId: "46318",
  arachimL3UserId: "46319",
  arachimL4UserId: "46320",
  arachimL5UserId: "46321",
  arachimL6UserId: "46322",
  arachimL7UserId: "46323",
  eltaServer: "47301",
  eltaServerIP1: "207.232.27.5",
  eltaServerIP2: "185.253.72.114",
  cadenceUserId : "45975"
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
